import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["inputRef"];
import React, { Component } from 'react';
import wrapDisplayName from 'recompose/wrapDisplayName';
var startAnimationName = 'onAutofillStart';
var endAnimationName = 'onAutofillCancel';
var styleElementId = 'autofill-style';
var counterAttribute = 'data-counter';
var isWebkit = () => navigator.userAgent.indexOf('WebKit') !== -1;
function emptyAnimation(animationName) {
  return "\n    @keyframes ".concat(animationName, " {\n      from {/**/}\n      to {/**/}\n    }\n  ");
}
function injectStyle(style, targetDocument) {
  var styleSheet = targetDocument.getElementById(styleElementId).sheet;
  try {
    styleSheet.insertRule(style, styleSheet.cssRules.length);
  } catch (err) {
    console.warn('style injection failed');
  }
}
function injectKeyFrames(targetDocument) {
  var autofillStartEmptyKeyframesStyle = emptyAnimation(startAnimationName);
  var autofillEndEmptyKeyframesStyle = emptyAnimation(endAnimationName);
  injectStyle(autofillStartEmptyKeyframesStyle, targetDocument);
  injectStyle(autofillEndEmptyKeyframesStyle, targetDocument);
}
function injectAutofillHook(targetDocument) {
  // Expose a hook for JavaScript when autofill is shown.
  // JavaScript can capture 'animationstart' events
  // Change the backgound color _really slowly_
  var autofillHook = "\n    input:-webkit-autofill {\n      animation-name: ".concat(startAnimationName, ";\n      transition: background-color 50000s ease-in-out 0s;\n    }\n  ");

  // Expose a hook for JavaScript when autofill is no longer shown.
  // JavaScript can capture 'animationstart' events
  var notAutofillHook = "\n    input:not(:-webkit-autofill) {\n      animation-name: ".concat(endAnimationName, ";\n    }");
  injectStyle(autofillHook, targetDocument);
  injectStyle(notAutofillHook, targetDocument);
}
function registerAutofill(targetDocument) {
  if (!isWebkit()) {
    return;
  }
  var autofillStyle = targetDocument.getElementById(styleElementId);
  if (!autofillStyle) {
    autofillStyle = targetDocument.createElement('style');
    autofillStyle.id = styleElementId;
    autofillStyle.setAttribute(counterAttribute, 0);
    targetDocument.head.appendChild(autofillStyle);
    injectKeyFrames(targetDocument);
    injectAutofillHook(targetDocument);
  } else {
    var usageCounter = autofillStyle.getAttribute(counterAttribute);
    usageCounter++;
    autofillStyle.setAttribute(counterAttribute, usageCounter);
  }
}
function unregisterAutofill(targetDocument) {
  if (!isWebkit()) {
    return;
  }
  if (targetDocument) {
    var autofillStyle = targetDocument.getElementById(styleElementId);
    if (autofillStyle) {
      var usageCounter = autofillStyle.getAttribute(counterAttribute);
      usageCounter--;
      autofillStyle.setAttribute(counterAttribute, usageCounter);
      if (usageCounter === 0) {
        // remove element
        autofillStyle.outerHTML = '';
      }
    }
  }
}
export default (autofillProps => Target => {
  class WithAutofillProps extends Component {
    constructor() {
      super();
      this.state = {
        autofill: false
      };
      this.handleAnimation = this.handleAnimation.bind(this);
    }
    componentWillUnmount() {
      unregisterAutofill(this.contentDomElement ? this.contentDomElement.ownerDocument : global.document);
    }
    handleAnimation(e) {
      switch (e.animationName) {
        case startAnimationName:
          if (this.props.onAutofill) {
            this.props.onAutofill();
          }
          return this.setState({
            autofill: true
          });
        case endAnimationName:
          if (this.props.onEndAutofill) {
            this.props.onEndAutofill();
          }
          return this.setState({
            autofill: false
          });
      }
    }
    render() {
      var {
        autofill
      } = this.state;
      var _this$props = this.props,
        {
          inputRef
        } = _this$props,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(Target, _extends({
        onAnimationStart: this.handleAnimation,
        inputRef: contentDomElement => {
          this.contentDomElement = contentDomElement;

          // if inputRef is callback ref
          if (typeof inputRef === 'function') {
            inputRef && inputRef(contentDomElement);
          }

          // if inputRef is ref
          if (typeof inputRef === 'object') {
            inputRef.current = contentDomElement;
          }
          if (contentDomElement) {
            registerAutofill(contentDomElement.ownerDocument || global.document);
          }
        }
      }, restProps, autofill && autofillProps));
    }
  }
  WithAutofillProps.displayName = wrapDisplayName(Target, 'withAutofillProps');
  return WithAutofillProps;
});
//# sourceMappingURL=index.js.map